---
/**
 * !!! Be Careful With This File !!!
 *
 * It is imported in a Preact Island component. It cannot include anything that is Node-specific, like process.
 */
import { Image } from "astro:assets";
import archGif from "@public/wp/icons/arch-icon.gif";

interface Props {
  iconName?: string;
}

const { iconName } = Astro.props;

const images: {
  [x: string]: () => Promise<typeof import("@icons/arch-icon")>;
} = {
  arch: () => import("@icons/arch-icon"),
  arrow_right: () => import("@icons/arrow_right-icon"),
  arrow_mapping: () => import("@icons/arrow_mapping-icon"),
  balance: () => import("@icons/balance-icon"),
  briefcase: () => import("@icons/briefcase-icon"),
  calendar: () => import("@icons/calendar-icon"),
  chair: () => import("@icons/chair-icon"),
  chats: () => import("@icons/chats-icon"),
  check: () => import("@icons/check-icon"),
  circle_check: () => import("@icons/circle-check-icon"),
  circle_x: () => import("@icons/circle-x-icon"),
  clipboard: () => import("@icons/clipboard-icon"),
  coffee_cup: () => import("@icons/coffee_cup-icon"),
  community: () => import("@icons/community-icon"),
  computer: () => import("@icons/computer-icon"),
  cupped_hands: () => import("@icons/cupped_hands-icon"),
  door: () => import("@icons/door-icon"),
  eye: () => import("@icons/eye-icon"),
  eyeballs: () => import("@icons/eyeballs-icon"),
  facebook: () => import("@icons/facebook-icon"),
  gas_pump: () => import("@icons/gas_pump-icon"),
  gear: () => import("@icons/gear-icon"),
  hand: () => import("@icons/hand-icon"),
  happy_chat: () => import("@icons/happy_chat-icon"),
  heart: () => import("@icons/heart-icon"),
  holding_hands: () => import("@icons/holding_hands-icon"),
  home: () => import("@icons/home-icon"),
  id_badge: () => import("@icons/id_badge-icon"),
  illustration_maze: () => import("@icons/illustration-maze"),
  info: () => import("@icons/info-icon"),
  instagram: () => import("@icons/instagram-icon"),
  invoice: () => import("@icons/invoice-icon"),
  light_bulb: () => import("@icons/light_bulb-icon"),
  "linked-in": () => import("@icons/linked-in-icon"),
  maze: () => import("@icons/maze-icon"),
  medal: () => import("@icons/medal-with-dollar-sign-icon"),
  medicine: () => import("@icons/medicine-icon"),
  news: () => import("@icons/news-icon"),
  partly_sunny: () => import("@icons/partly_sunny-icon"),
  person_plus: () => import("@icons/person_plus-icon"),
  plant: () => import("@icons/plant-icon"),
  prescription: () => import("@icons/prescription-icon"),
  rabbit: () => import("@icons/rabbit-icon"),
  search_person: () => import("@icons/search_person-icon"),
  single_chair: () => import("@icons/single_chair-icon"),
  smiling_face_with_hearts_emoji: () => import("@icons/smiling_face_with_hearts_emoji-icon"),
  stars: () => import("@icons/stars-icon"),
  target: () => import("@icons/target-icon"),
  tiktok: () => import("@icons/tiktok-icon"),
  verified: () => import("@icons/verified-icon"),
  x: () => import("@icons/x-icon"),
};
let ImageIcon;
if (iconName && iconName !== "none") {
  if (images[iconName]) {
    ImageIcon = await images[iconName]();
  }
}
---

{
  iconName === "none" ? null : iconName === "arch" ? (
    <Image src={archGif} alt={`${iconName} icon`} />
  ) : (
    <>{ImageIcon && <ImageIcon.default />}</>
  )
}
